// #MARK Header Scroll
jQuery( function($) {
  $( window ).on( 'scroll', function () {
    var header = $( '.rwt-main-header' ), body = $( 'body' );
    if ( $( window ).scrollTop() >= 40 ) {
      header.addClass( 'small' );
      body.addClass( 'rwt-header-small' );
    } else {
      header.removeClass( 'small' );
      body.removeClass( 'rwt-header-small' );
    }
  } ).trigger( 'scroll' );
} );

// #MARK Header Searchfield
jQuery( function ($) {
  $( '#rwt-header .rwt-search-form .search-submit').on( 'click submit', function ( event ) {
    var button = $(this), input = button.siblings( '.search-field' );

    if ( '' == input.val() ) {
      event.preventDefault();
      input.focus();
      return false;
    }
  } );

  $( '#rwt-header .rwt-search-form .search-field').on( 'change', function () {
    var input = $(this);

    if ( '' == input.val() ) {
      input.removeAttr( 'value' );
    } else {
      input.attr( 'value' , input.val() );
    }
  } );
} );

// #MARK Sharing
jQuery(function($) {
  $('.rwt-sharing a.share').each( function() {
    $(this).on('click', function(event) {
      var $this = $(this);
      if ( $this.attr('data-window-open') ) {
        event.preventDefault();
        var screenX     = 'undefined' != typeof(window.screenX) ? window.screenX : window.screenLeft,
            screenY     = 'undefined' != typeof(window.screenY) ? window.screenY : window.screenTop,
            screenXpos  = (0 > screenX) ? (window.screen.width + screenX) : screenX,
            outerWidth  = 'undefined' != typeof(window.outerWidth) ? window.outerWidth : document.documentElement.clientWidth,
            outerHeight = 'undefined' != typeof(window.outerHeight) ? window.outerHeight : (document.documentElement.clientHeight - 22),
            width       = parseInt($this.attr('data-window-open-width'), 10),
            height      = parseInt($this.attr('data-window-open-height'), 10),
            left        = parseInt(screenXpos + ((outerWidth - width) / 2), 10),
            top         = parseInt(screenY + ((outerHeight - height) / 2.5), 10),
            specs       = 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes' + ',top=' + top +',left=' + left +',width=' + width +',height=' + height;

        var popup = window.open($this.attr('href'), undefined, specs);

        if(window.focus) {
          popup.focus();
        }
      }

      if (undefined !== window.gtag) {
        gtag( 'event', 'share', {method: $this.data('social-network'), item_id: $this.data('social-target')} );
      } else if (undefined !== window.ga) {
        ga('send', 'social', $this.attr('data-social-network'), $this.attr('data-social-action'), $this.attr('data-social-target'));
      }
    } );
  } );
} );

// #MARK Featherlight
jQuery(function($) {
  // Lightbox for galleries
  $('.gallery-item a').featherlightGallery({
    //targetAttr : 'href',
    previousIcon: '&larr;',
    nextIcon: '&rarr;',
    openSpeed: 300,
    beforeOpen: function(event){
      var href = $(event.currentTarget).attr('href');
      if (href) {
        var file = href.split('.').pop();
        if ($.inArray(file, ['jpg','jpeg','gif','png']) < 0) {
          return false;
        }
      }
    }
  });
});

// #MARK Woo Cart contents
jQuery(function($) {
  if ( typeof rwt_ms === 'undefined' || rwt_ms === null ) {
    return;
  }

  var $cart = $( '#rwt-header .top-navigation .cart > a' );

  if ( $cart.length ) {
    $.getJSON( rwt_ms.apiSettings.root + 'wc/store/cart/items', function( data ) {
      var count = i = 0;
      for ( ; i < data.length; i++ ) {
        count += data[i].quantity;
      }

      if ( count > 0 ) {
        $cart.append( '<div class="in-cart">' + count + '</div>');
      }
    } )
  }
});
